// extracted by mini-css-extract-plugin
export var specialOfferPage = "specialOffer-module--specialOfferPage--QRN+B";
export var wrapper = "specialOffer-module--wrapper--rwBDn";
export var inner = "specialOffer-module--inner--kTLnr";
export var disclaimer = "specialOffer-module--disclaimer--MMycK";